/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * XSOAR Account Mapping
 * @export
 * @interface XsoarAccountMappingDto
 */
export interface XsoarAccountMappingDto {
    /**
     * XSOAR account ID
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    xsoarAccountId?: string;
    /**
     * XSOAR account name
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    xsoarAccountName?: string;
    /**
     * XSOAR instance URL (optional)
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    xsoarInstanceUrl?: string;
    /**
     * XSOAR API Key ID - Integer value that ties the API key to a specific XSOAR account
     * @type {number}
     * @memberof XsoarAccountMappingDto
     */
    apiKeyId?: number;
    /**
     * XSOAR API Key - Send plaintext on create/update (backend encrypts automatically). Returns encrypted value (AES/GCM) that can be decrypted by trusted consumers.
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    xsoarApiKey?: string;
    /**
     * External sync process URL for health monitoring
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    externalSyncProcessUrl?: string;
    /**
     * Integration status
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    integrationStatus?: XsoarAccountMappingDtoIntegrationStatusEnum;
    /**
     * Last sync timestamp
     * @type {Date}
     * @memberof XsoarAccountMappingDto
     */
    lastSyncTimestamp?: Date;
    /**
     * Sync status
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    syncStatus?: XsoarAccountMappingDtoSyncStatusEnum;
    /**
     * Whether case synchronization is enabled for this account mapping
     * @type {boolean}
     * @memberof XsoarAccountMappingDto
     */
    syncEnabled?: boolean;
    /**
     * Additional metadata and configuration
     * @type {{ [key: string]: any; }}
     * @memberof XsoarAccountMappingDto
     */
    metadata?: { [key: string]: any; };
    /**
     * Sync details and metrics
     * @type {{ [key: string]: any; }}
     * @memberof XsoarAccountMappingDto
     */
    syncDetails?: { [key: string]: any; };
    /**
     * Error message if sync failed
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    errorMessage?: string;
    /**
     * Tenant ID this mapping belongs to
     * @type {string}
     * @memberof XsoarAccountMappingDto
     */
    tenantId?: string;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof XsoarAccountMappingDto
     */
    createdAt?: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof XsoarAccountMappingDto
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const XsoarAccountMappingDtoIntegrationStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Suspended: 'suspended'
} as const;
export type XsoarAccountMappingDtoIntegrationStatusEnum = typeof XsoarAccountMappingDtoIntegrationStatusEnum[keyof typeof XsoarAccountMappingDtoIntegrationStatusEnum];

/**
 * @export
 */
export const XsoarAccountMappingDtoSyncStatusEnum = {
    Success: 'success',
    Failed: 'failed',
    Partial: 'partial',
    InProgress: 'in progress'
} as const;
export type XsoarAccountMappingDtoSyncStatusEnum = typeof XsoarAccountMappingDtoSyncStatusEnum[keyof typeof XsoarAccountMappingDtoSyncStatusEnum];


/**
 * Check if a given object implements the XsoarAccountMappingDto interface.
 */
export function instanceOfXsoarAccountMappingDto(value: object): value is XsoarAccountMappingDto {
    return true;
}

export function XsoarAccountMappingDtoFromJSON(json: any): XsoarAccountMappingDto {
    return XsoarAccountMappingDtoFromJSONTyped(json, false);
}

export function XsoarAccountMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): XsoarAccountMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'xsoarAccountId': json['xsoar_account_id'] == null ? undefined : json['xsoar_account_id'],
        'xsoarAccountName': json['xsoar_account_name'] == null ? undefined : json['xsoar_account_name'],
        'xsoarInstanceUrl': json['xsoar_instance_url'] == null ? undefined : json['xsoar_instance_url'],
        'apiKeyId': json['api_key_id'] == null ? undefined : json['api_key_id'],
        'xsoarApiKey': json['xsoar_api_key'] == null ? undefined : json['xsoar_api_key'],
        'externalSyncProcessUrl': json['external_sync_process_url'] == null ? undefined : json['external_sync_process_url'],
        'integrationStatus': json['integration_status'] == null ? undefined : json['integration_status'],
        'lastSyncTimestamp': json['last_sync_timestamp'] == null ? undefined : (new Date(json['last_sync_timestamp'])),
        'syncStatus': json['sync_status'] == null ? undefined : json['sync_status'],
        'syncEnabled': json['sync_enabled'] == null ? undefined : json['sync_enabled'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'syncDetails': json['sync_details'] == null ? undefined : json['sync_details'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function XsoarAccountMappingDtoToJSON(json: any): XsoarAccountMappingDto {
    return XsoarAccountMappingDtoToJSONTyped(json, false);
}

export function XsoarAccountMappingDtoToJSONTyped(value?: XsoarAccountMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'xsoar_account_id': value['xsoarAccountId'],
        'xsoar_account_name': value['xsoarAccountName'],
        'xsoar_instance_url': value['xsoarInstanceUrl'],
        'api_key_id': value['apiKeyId'],
        'xsoar_api_key': value['xsoarApiKey'],
        'external_sync_process_url': value['externalSyncProcessUrl'],
        'integration_status': value['integrationStatus'],
        'last_sync_timestamp': value['lastSyncTimestamp'] == null ? undefined : ((value['lastSyncTimestamp']).toISOString()),
        'sync_status': value['syncStatus'],
        'sync_enabled': value['syncEnabled'],
        'metadata': value['metadata'],
        'sync_details': value['syncDetails'],
        'error_message': value['errorMessage'],
        'tenant_id': value['tenantId'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

